function Spacer({ flex = 1 }: { flex?: number }) {
  return <div style={{ flex }} />;
}

export default Spacer;
